import classNames from 'classnames';

// styles
import s from './SellerRatingItem.sss';

// types
type SellerRatingPreloaderProps = {
  className?: string;
};

export const SellerRatingPreloader: React.FC<SellerRatingPreloaderProps> = ({
  className,
}) => (
  <div className={classNames(s.placeholder, className)}>
    <div className={s.topPreloader} />
    <div className={s.bottomPreloader} />
  </div>
);
